<template>
  <CContainer>
    <CRow>
      <CCol col="sm-6">
        <CInput 
          label="Buscar:" 
          addLabelClasses="text-muted font-weight-bold"
          :value.sync="searchWord" 
          @keyup.enter="getData(1, searchWord)">
          <template #prepend-content>
            <a href="#" class="text-dark" @click="getData(1)">
              <i class="bi bi-arrow-clockwise"></i>
            </a>
          </template>
          <template #append-content>
            <a href="#" @click="getData(1, searchWord)">
              <i class="bi bi-search"></i>
            </a>
          </template>
        </CInput>
      </CCol>
    </CRow>
    <CDataTable
      hover
      responsive
      class="table-hover-icons"
      :items="records"
      :fields="gridFields">
      <template #documento="{item}">
        <td>
          <div>
            <h5>{{ item.prefijo }} {{ item.numero }}</h5>
          </div>
          <div>
            <span>{{ item.tipo_Documento }}</span>
          </div>
        </td>
      </template>
      <template #cliente="{item}">
        <td>
          <div>
            <CIcon name="cil-building" class="mr-1" />
            <span>{{ item.empresa }}</span>
          </div>
          <div>
            <i class="bi bi-postcard mr-1"></i>
            <span>{{ item.identificacion }}</span>
          </div>
        </td>
      </template>
      <template #serial="{item}">
        <td>
          <div>
            <span><i class="bi bi-upc-scan mr-2"></i>{{ item.numero_Serial }}</span>
          </div>
          <div>
            <span><i class="bi bi-calendar3 mr-2"></i>{{ moment(item.fecha_Creacion).format("DD/MM/YYYY") }}</span>
          </div>
          <div>
            <span><i class="bi bi-clock mr-2"></i>{{ moment(item.fecha_Creacion).format("hh:mm:ss") }}</span>
          </div>
        </td>
      </template>
      <template #actions="{item}">
        <td class="d-flex justify-content-end">
          <div class="hover-actions">
            <a href="#" v-if="$store.state.user.data.tipo_Empleado === 'A'"
              @click="(e) => tryDelete(e, item.id_MovimientoSerialProducto)">
              <i class="bi bi-trash text-danger h4 mr-2 hover-icon"></i>
            </a>
          </div>
        </td>
      </template>
    </CDataTable>
    <CPagination
      size="sm"
      class="d-flex justify-content-center"
      :activePage.sync="page"
      :pages="pageCount"
      @update:activePage="(value, a) => getData(value, searchWord)"
    />

    <CElementCover v-show="loading"/>
  </CContainer>
</template>

<script>
  import moment from "moment"
  import CONSTANTS from "@/constants";
  import { crudMovimientosSerialesProductos } from "@/apis/serials";
  import { dataGridSerialesProducto } from "../../apiDataGrids"

  const gridFields = [
    {
      key: "documento",
      label: "Documento",
      _style: "text-align:center"
    },
    {
      key: "cliente",
      label: "Empresa",
      _style: "text-align:center"
    },
    {
      key: "serial",
      label: "Serial",
      _style: "text-align:center"
    },
    {
      key: "actions",
      label: "",
      _style: "text-align:center"
    }
  ]

  export default {
    name: "SerialsProduct",
    data () {
      return {
        loading: false,
        gridFields,
        // fieldsExport,
        records: [],
        numberRecords: 0,
        page: 1,
        pageCount: 1,
        itemsPerPage: 5,
        searchWord: "",
        movimientoSerialProductoId: null
      }
    },
    props: {
      idProduct: String
    },
    methods: {
      moment,
      async getData(page, search) {
        if (this.idProduct) {
          try {
            this.loading = true
            this.page = page
            this.searchWord = search

            const { count, results } = await dataGridSerialesProducto(this, this.idProduct, page, search)
            
            this.numberRecords = count
            this.pageCount = parseInt(count / this.itemsPerPage)
            if (this.pageCount < (count / this.itemsPerPage)) {
              this.pageCount++
            } 
            this.records = results
          } catch(error) {
            this.$store.commit("setAlert", {
              color: "danger",
              message: "NO se pudo cargar los datos de Seriales del Productos.",
              show: 5
            })
          } finally {
            this.loading = false
          }
        }
      },
      tryDelete(e, id) {
        e.preventDefault();
        e.stopPropagation();

        this.movimientoSerialProductoId = id;

        CONSTANTS.configSimpleConfirm.confirmButtonText = "Borrar"
        CONSTANTS.configSimpleConfirm.confirmButtonColor = "red"

        this.$confirm("¿Confirma que desea borrar este registro?", "", "question", CONSTANTS.configSimpleConfirm).then(() => {
          this.deleteRecord();
        }).catch(() => {
          this.$alert("¡Se cancelo la acción!", "", "warning", CONSTANTS.configSimpleAlert);
        });
      },
      async deleteRecord() {
        this.loading = true;

        try {
          await crudMovimientosSerialesProductos(this, "delete", this.movimientoSerialProductoId);

          this.$store.commit("setAlert", {
            color: "success",
            message: CONSTANTS.messages.successfulAction,
            show: 5
          });
        } catch (error) {
          this.$store.commit("setAlert", {
            color: "danger",
            message: CONSTANTS.messages.notDoneDelete,
            show: 5
          });
        } finally {
          this.loading = false;
        }
      }
    },
    mounted() {
      this.getData(1)
    }
  }
</script>
